import React, { useEffect, useState } from "react";
import axios from "axios";

const PendingTransactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPendingTransactions = async () => {
      try {
        const response = await axios.get(
          "https://api.vyapakprint.com/api/distribution/distributions/pending-transactions"
        );
        setTransactions(response.data);
      } catch (error) {
        console.error("Error fetching transactions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPendingTransactions();
  }, []);

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Pending Transactions</h2>
      {loading ? (
        <p>Loading...</p>
      ) : transactions.length === 0 ? (
        <p>No pending transactions found.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border rounded shadow">
            <thead className="bg-gray-100 text-left">
              <tr>
                <th className="p-3 border">#</th>
                <th className="p-3 border">Contact Person</th>
                <th className="p-3 border">Email</th>
                <th className="p-3 border">Mobile</th>
                <th className="p-3 border">Amount</th>
                <th className="p-3 border">Remark</th>

                <th className="p-3 border">Type</th>
                <th className="p-3 border">Date</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((item, index) => (
                <tr
                  key={item.transaction._id}
                  className="border-b hover:bg-gray-50"
                >
                  <td className="p-3 border">{index + 1}</td>
                  <td className="p-3 border">{item.contactPerson}</td>
                  <td className="p-3 border">{item.email}</td>
                  <td className="p-3 border">{item.mobile}</td>
                  <td className="p-3 border">₹{item.transaction.amount}</td>
                  <td className="p-3 border">{item.transaction.remark}</td>
                  <td className="p-3 border capitalize">
                    {item.transaction.transactionType}
                  </td>
                  <td className="p-3 border">
                    {new Date(item.transaction.date).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PendingTransactions;
